const TABLE_DENSITIES = ["spacious", "comfortable", "compact"];

export const normalizeTableDensity = (value) => {
  return TABLE_DENSITIES.includes(value) ? value : "comfortable";
};

export const getTableDensityStyles = (densityValue) => {
  const density = normalizeTableDensity(densityValue);
  const compact = density === "compact";

  return {
    density,
    headCell: compact ? { py: "1px", px: "5px", fontSize: "0.75rem" } : {},
    bodyCell: compact ? { py: "1px", px: "5px", fontSize: "0.75rem" } : {},
    bodyRow: compact ? { "& td": { py: "1px !important" }, minHeight: "28px" } : {},
    actionsColumnSize: compact ? 180 : 250,
    actionButton: compact ? { padding: "4px 10px", fontSize: "12px" } : undefined,
  };
};

